import { render, staticRenderFns } from "./addDiscountRule.vue?vue&type=template&id=73d5d496&scoped=true"
import script from "./addDiscountRule.vue?vue&type=script&lang=js"
export * from "./addDiscountRule.vue?vue&type=script&lang=js"
import style0 from "./addDiscountRule.vue?vue&type=style&index=0&id=73d5d496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d5d496",
  null
  
)

export default component.exports